import { FuelRadio, FuelTypography, FuelTag } from '@frete.com/fuel-react'
import styled, { css } from 'styled-components'
import { LabelProps, SelectProps } from './interfaces'

export const Label = styled(FuelTypography).attrs({ as: 'h6' })<LabelProps>`
  color: ${({ theme, $state }) => $state && theme.color.text[$state].strong};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  font-size: ${({ theme }) => theme.font.size.m2};
  line-height: ${({ theme }) => theme.font.lineHeight.large};
  margin-bottom: ${({ theme }) => theme.spacing.km1};
`

export const Input = styled.input`
  opacity: 0;
  bottom: 0;
  left: 0;
  position: absolute;
  opacity: 0;
  pointer-events: none;
  width: 100%;
  box-sizing: border-box;
`

export const Select = styled.div<SelectProps>`
  background: ${({ theme }) => theme.color.background.neutral.default};
  border-color: ${({ theme, $state }) =>
    $state ? theme.color.border[$state].default : theme.color.border.neutral.medium};
  border-radius: ${({ theme }) => theme.border.radius.medium};
  border-width: ${({ theme }) => theme.border.width.thinner};
  border-style: ${({ theme }) => theme.border.style.solid};
  width: 100%;
  height: 48px;
  appearance: none !important;
  color: ${({ theme, itemSelected }) =>
    itemSelected ? theme.color.text.neutral.strong : theme.color.text.neutral.weak};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  font-size: ${({ theme }) => theme.font.size.m3};
  line-height: ${({ theme }) => theme.font.lineHeight.medium};
  padding: ${({ theme }) => theme.padding.km3};
  display: flex;
  justify-content: space-between;
  cursor: pointer;

  ${({ $disabled }) =>
    $disabled &&
    css`
      background: ${({ theme }) => theme.color.background.neutral.weak};
      cursor: default;
    `}
`

export const Icon = styled.div<SelectProps>`
  padding-left: 10px;
  color: ${({ theme }) => theme.color.icon.neutral.default};
  ${({ $disabled }) =>
    $disabled &&
    css`
      background: ${({ theme }) => theme.color.background.neutral.weak};
      cursor: default;
    `}
`

export const Wrapper = styled.div`
  position: relative;
`

export const BottomText = styled(FuelTypography).attrs({ as: 'p' })`
  font-weight: ${({ theme }) => theme.font.weight.medium};
  font-size: ${({ theme }) => theme.font.size.m2};
  margin-top: 6px;
  margin-left: ${({ theme }) => theme.spacing.km1};
  position: absolute;
`

export const Error = styled(BottomText)`
  color: ${({ theme }) => theme.color.text.danger.default};
`

export const Message = styled(BottomText)`
  color: ${({ theme }) => theme.color.text.neutral.default};
`
export const Option = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  &:hover {
    background: #f8f9fa;
  }
`

export const Radio = styled(FuelRadio)`
  label > span > span {
    font-style: normal;
    font-weight: ${({ theme }) => theme.font.weight.medium};
    font-size: ${({ theme }) => theme.font.size.m3};
    line-height: ${({ theme }) => theme.font.lineHeight.medium};
    color: ${({ theme }) => theme.color.text.neutral.strong};
  }
`
export const AccessOption = styled.span`
  display: flex;
  flex-direction: column;
`

export const DescContent = styled.div` 
  display: flex;
  justify-content: space-between;

`